module.exports = __webpack_public_path__ + "static/gallery_wild_5_thumb-30a03e367aff51a4a176b7df23e835ce.jpg";